/**
 * Sentry — error monitoring frontend.
 * Lit la DSN depuis REACT_APP_SENTRY_DSN. Init silencieuse si absente.
 */
import * as Sentry from '@sentry/react';

export const initSentry = () => {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) {
    // Pas d'erreur, mode dégradé silencieux
    return false;
  }
  try {
    Sentry.init({
      dsn,
      environment: process.env.REACT_APP_SENTRY_ENV || 'production',
      // Capture des erreurs uniquement (pas de session replay = gratuit)
      tracesSampleRate: 0.05,
      // N'envoie pas les emails / téléphones (RGPD)
      sendDefaultPii: false,
      // Ignorer les erreurs réseau bénignes (annulation user, offline)
      ignoreErrors: [
        'Non-Error promise rejection captured',
        'ResizeObserver loop limit exceeded',
        'Network request failed',
        'Load failed',
        'AbortError',
      ],
      release: process.env.REACT_APP_VERSION || 'phciesada@dev',
    });
    return true;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Sentry init failed', e);
    return false;
  }
};

export { Sentry };
